// CoursesApiService.js
import BaseInternalApiService from './BaseInternalApiService';

class CourseApiService extends BaseInternalApiService {
  /**
   * Get all courses (admin only)
   */
  getCourses = async ({ page = 1, pageSize = 10, search = "", sort, category, priceMin, priceMax, status } = {}) => {
    try {
      const params = {
        page,
        pageSize,
        search: search?.trim() || "",
      };
      if (sort) params.sort = sort;
      if (category) {
        if (Array.isArray(category)) {
          params.category = category.join(",");
        } else {
          params.category = category;
        }
      }
      if (priceMin !== undefined) params.priceMin = priceMin;
      if (priceMax !== undefined) params.priceMax = priceMax;
      if (status) params.status = status;
      const response = await this.getAxiosInstance().get("/courses", {
        params,
      });
      return {
        courses: response.data?.data?.courses.map(course => ({
          ...course,
          key: course._id
        })) || [],
        pagination: response.data?.data?.pagination || {},
      };
    } catch (error) {
      console.error("Error getting courses:", error);
      throw error;
    }
  };


  /**
   * Get a course by ID (admin only)
   */
  getCourseById = async (courseId) => {
    try {
      const response = await this.getAxiosInstance().get(`/courses/${courseId}`);
      return response.data;
    } catch (error) {
      console.error("Error getting course by ID:", error);
      throw error;
    }
  };

  /**
   * Create a new course (admin only)
   */
  createCourse = async (formData) => {
    try {
      const response = await this.getAxiosInstance().post("/courses", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating course:", error);
      throw error;
    }
  };

  /**
   * Update a course (admin only)
   */
  updateCourse = async (courseId, formData) => {
    try {
      const response = await this.getAxiosInstance().put(`/courses/${courseId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating course:", error);
      throw error;
    }
  };

  /**
   * Delete a course (admin only)
   */
  deleteCourse = async (courseId) => {
    try {
      const response = await this.getAxiosInstance().delete(`/courses/${courseId}`);
      return response.data?.data || {};
    } catch (error) {
      console.error("Error deleting course:", error);
      throw error;
    }
  };
}

export default new CourseApiService();
